import {
  List,
  Datagrid,
  TextField,
  NumberField,
  DateField,
  BooleanField,
  SearchInput,
  BooleanInput,
  NumberInput,
  FilterButton,
  TopToolbar,
  ExportButton,
  FunctionField,
} from 'react-admin';

const userFilters = [
  <SearchInput
    key="search"
    source="search"
    alwaysOn
    placeholder="Search username or name"
  />,
  <BooleanInput key="banned" source="is_blacklisted" label="Banned only" />,
  <NumberInput key="min-volume" source="min_volume" label="Min Volume ($)" />,
];

const UserListActions = () => (
  <TopToolbar>
    <FilterButton />
    <ExportButton />
  </TopToolbar>
);

export const UserList = () => (
  <List
    filters={userFilters}
    actions={<UserListActions />}
    perPage={50}
    sort={{ field: 'total_volume_usd', order: 'DESC' }}
  >
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <TextField source="id" label="ID" />
      <TextField source="username" />
      <TextField source="first_name" label="Name" />
      <NumberField source="total_bets" />
      <NumberField
        source="total_volume_usd"
        options={{ style: 'currency', currency: 'USD' }}
        label="Volume"
      />
      <FunctionField
        label="Win Rate"
        render={(record: any) => `${(record?.win_rate_percent || 0).toFixed(1)}%`}
      />
      <BooleanField source="is_blacklisted" label="Banned" />
      <DateField source="last_bet_at" showTime label="Last Bet" />
    </Datagrid>
  </List>
);
